<div class="flex flex-col gap-3">
  <div class="grid grid-cols-2 gap-3">
    <div class="flex min-w-0 flex-col gap-2">
      <label class="text-sm font-medium text-slate-700">Alignment</label>
      <div class="inline-flex rounded-xl border border-slate-200 bg-slate-50/80 p-1">
        @for (option of alignmentOptions; track option.value) {
          <button
            type="button"
            class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-lg transition"
            [class.bg-white]="alignment() === option.value"
            [class.text-slate-900]="alignment() === option.value"
            [class.shadow-sm]="alignment() === option.value"
            [class.ring-1]="alignment() === option.value"
            [class.ring-slate-200/80]="alignment() === option.value"
            [class.text-slate-500]="alignment() !== option.value"
            [class.hover:text-slate-700]="alignment() !== option.value"
            [attr.aria-label]="option.label"
            [attr.aria-pressed]="alignment() === option.value"
            (click)="alignmentChange.emit(option.value)">
            <app-svg-icon [src]="option.icon" [size]="18" />
          </button>
        }
      </div>
    </div>

    <div class="flex min-w-0 flex-col gap-2">
      <label class="text-sm font-medium text-slate-700">Font Style</label>
      <div class="inline-flex rounded-xl border border-slate-200 bg-slate-50/80 p-1">
        @for (option of fontStyleOptions; track option.value) {
          <button
            type="button"
            class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-lg transition"
            [class.bg-white]="fontStyle() === option.value"
            [class.text-slate-900]="fontStyle() === option.value"
            [class.shadow-sm]="fontStyle() === option.value"
            [class.ring-1]="fontStyle() === option.value"
            [class.ring-slate-200/80]="fontStyle() === option.value"
            [class.text-slate-500]="fontStyle() !== option.value"
            [class.hover:text-slate-700]="fontStyle() !== option.value"
            [attr.aria-label]="option.label"
            [attr.aria-pressed]="fontStyle() === option.value"
            (click)="fontStyleChange.emit(option.value)">
            <app-svg-icon [src]="option.icon" [size]="18" />
          </button>
        }
      </div>
    </div>
  </div>

  <div class="flex flex-col gap-2">
    <label class="text-sm font-medium text-slate-700">Font Weight</label>
    <div class="flex w-full rounded-xl border border-slate-200 bg-slate-50/80 p-1">
      @for (option of fontWeightOptions; track option.value) {
        <button
          type="button"
          class="flex h-8 min-w-0 flex-1 cursor-pointer items-center justify-center rounded-lg px-1 text-xs transition"
          [class.bg-white]="fontWeight() === option.value"
          [class.text-slate-900]="fontWeight() === option.value"
          [class.shadow-sm]="fontWeight() === option.value"
          [class.ring-1]="fontWeight() === option.value"
          [class.ring-slate-200/80]="fontWeight() === option.value"
          [class.text-slate-500]="fontWeight() !== option.value"
          [class.hover:text-slate-700]="fontWeight() !== option.value"
          [attr.aria-label]="option.label"
          [attr.aria-pressed]="fontWeight() === option.value"
          (click)="fontWeightChange.emit(option.value)">
          <span [style.font-weight]="option.value">{{ option.label }}</span>
        </button>
      }
    </div>
  </div>
</div>
